import { Link } from "react-router-dom";
import type { AccountBalance, Currency, LedgerAccount } from "../../entities/ledger/types";
import { AccountTile, distinctLabels } from "./AccountTile";

interface AccountsPanelProps {
  accounts: LedgerAccount[];
  balances: AccountBalance[];
  reportingCurrency?: Currency;
  // Overview: show the first few and link to the full list.
  limit?: number;
}

export function AccountsPanel({ accounts, balances, reportingCurrency, limit }: AccountsPanelProps) {
  const positions = new Map(balances.map((balance) => [balance.account.id, balance]));
  const financialAccounts = accounts;
  const shown = limit ? financialAccounts.slice(0, limit) : financialAccounts;
  const distinct = distinctLabels(shown);

  return (
    <section className="section-block accounts-panel" aria-labelledby="accounts-title">
      <div className="panel-heading accounts-heading">
        <div><p className="eyebrow">Accounts</p><h2 id="accounts-title">Where your money lives</h2></div>
        <div className="heading-actions">
          {limit && financialAccounts.length > shown.length
            ? <Link className="secondary-button" to="/accounts">All {financialAccounts.length} accounts</Link>
            : <Link className="secondary-button" to="/accounts">Manage accounts</Link>}
        </div>
      </div>
      <div className="account-grid">
        {shown.map((account) => <AccountTile account={account} balance={positions.get(account.id)} reportingCurrency={reportingCurrency} labelIsDistinct={distinct.has(account.displayLabel ?? "")} key={account.id} />)}
        {financialAccounts.length === 0 ? (
          <Link className="open-account-link" to="/accounts/new">
            <span aria-hidden="true">＋</span><strong>Open your first account</strong><small>Bank, cash, PSP or liability</small>
          </Link>
        ) : null}
      </div>
    </section>
  );
}
